import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import {
  getRefreshTokenInfo,
  setRefreshTokenInfo
} from "@/utils/localStorageUtils";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    isAuthenticated: false,
    accessToken: "",
    accessTokenExpiresAt: "",
    printPage: false,
    images: [],
    cordova: false
  },
  mutations: {
    setAuthenticated(state, auth) {
      state.isAuthenticated = auth;
    },
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken;
      Vue.http.headers.common.Authorization = "BEARER " + accessToken;
    },
    setAccessTokenExpiresAt(state, accessTokenExpiresAt) {
      state.accessTokenExpiresAt = accessTokenExpiresAt;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.accessToken = "";
      state.accessTokenExpiresAt = "";
      state.printPage = false;
    },
    setPrintPage(state, printPage) {
      state.printPage = printPage;
    },
    setImages(state, images) {
      state.images = images;
    },
    clearImages(state) {
      state.images = [];
    },
    setCordova(state, cordova) {
      state.cordova = cordova;
    }
  },
  getters: {
    isUserAuthenticated: state => state.isAuthenticated,
    getAccessToken: state => state.accessToken,
    getAccessTokenExpiresAt: state => state.accessTokenExpiresAt,
    getPrintPage: state => state.printPage,
    getImages: state => state.images,
    getCordova: state => state.cordova
  },
  actions: {
    async fetchFreshToken({ commit }) {
      const { refresh_token: refreshToken } = getRefreshTokenInfo();
      const {
        body: { auth: authInfo }
      } = await Vue.http.post("doctors/token", { refresh_token: refreshToken });
      commit("setAccessToken", authInfo.access_token);
      commit("setAccessTokenExpiresAt", authInfo.access_token_expires_at);
      setRefreshTokenInfo(authInfo);
    },
    setCordova({ commit }, cordova) {
      commit("setCordova", cordova);
    }
  },
  plugins: [new VuexPersistence().plugin]
});

export default store;
